import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Brush,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { IChartProps, StickyTooltip } from '../../../../../component/charts';
import ChartCard from '../../../../../component/charts/chartCard';
import {
  labelFormatterBillions,
  labelFormatterMoneyAsFloat,
  labelFormatterPercentile,
} from '../../../../../shared/formatters/formatters';
import { updateRequestStatusMarketCycle } from '../../redux/marketCycle.actions';
import { SecondaryINCCChartData } from './types';

export const SecondaryINCC: React.FC = () => {
  const { requesStatusMarketCycle, chartsDataMarketCycle } = useSelector(
    (state: any) => state.marketCycleState
  );
  return (
    <ChartCard
      data={chartsDataMarketCycle['secondaryINCC']}
      Chart={SecondaryINCCChart}
      cy={'SecondaryINCC'}
      id={'secondaryINCC'}
      requestStatus={requesStatusMarketCycle['secondaryINCC']}
    />
  );
};

const SecondaryINCCChart: React.FC<IChartProps<SecondaryINCCChartData[]>> = ({
  data,
  cy,
  id,
}) => {
  const { preference } = useSelector((state: any) => state.layoutState);
  const nls = require(`../../nls/${preference.language.id}.json`);
  const [hasClicked, setHasClicked] = useState<boolean>(false);
  const [recordTooltip, setRecordTooltip] = useState<JSX.Element | null>(null);
  const [stopChange, setStopChange] = useState<boolean>(false);
  const formatterFunctions = [labelFormatterBillions, labelFormatterPercentile];
  const formattedData = data?.map((el, index) => ({
    ...el,
    value: el.value / 1000000000,
  }));
  const key = data ? `incc_in_${data[0].type}` : '';
  return (
    <ResponsiveContainer data-cy={`SecondaryINCC${cy}`}>
      <LineChart
        id={id}
        data={formattedData}
        margin={{
          top: 30,
          right: 30,
          left: 20,
          bottom: 5,
        }}
        onClick={() => setHasClicked(!hasClicked)}
      >
        <XAxis
          dataKey="period"
          padding={{ left: 30, right: 30 }}
          domain={['auto', 'dataMax']}
        />
        <Legend iconType="circle" />
        <YAxis
          yAxisId="price"
          orientation="left"
          tickFormatter={(value: number) =>
            `${labelFormatterMoneyAsFloat(value)}bi`
          }
          label={{
            value: nls.charts.secondaryINCC.price,
            position: 'top',
            offset: 15,
          }}
        ></YAxis>
        <YAxis
          yAxisId="percentile"
          orientation="right"
          tickFormatter={labelFormatterPercentile}
          label={{
            value: nls.charts.secondaryINCC.INCC,
            position: 'top',
            offset: 15,
          }}
        ></YAxis>
        <Tooltip
          wrapperStyle={{ visibility: 'visible' }}
          content={
            <StickyTooltip
              hasClicked={hasClicked}
              recordTooltip={recordTooltip}
              setRecordTooltip={setRecordTooltip}
              stopChange={stopChange}
              setStopChange={setStopChange}
              formatterFunctions={formatterFunctions}
            />
          }
        />
        <Line
          yAxisId="price"
          type="monotone"
          isAnimationActive={false}
          name={nls.charts.secondaryINCC.secondary_market_price}
          dataKey="value"
          stroke="#925AC4"
        ></Line>
        <Line
          yAxisId="percentile"
          type="monotone"
          isAnimationActive={false}
          name={nls.charts.secondaryINCC.INCC}
          dataKey={key}
          stroke="#3F205A"
        ></Line>
        <Brush dataKey="id" height={30} stroke="#8884d8" />
      </LineChart>
    </ResponsiveContainer>
  );
};
